export const numberFormat = (price: number): string => {

    return  price.toLocaleString('ru');
};
